import React from "react";
import "./OfferingCard.css";
import { Link } from "react-router-dom";
import Button from "../button/Button";
import '../../components/button/Button.css'
import { images } from "../../assets";

export default function OfferingCard({data,onButtonClick}) {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div className="offeringCard">
      <div className="offeringCardLeft">
        <div className="oclTop">
          <div className="oclTopTitle">{data.name}</div>
          <div className="oclTopDetail">
            {data.detail}
          </div>
        </div>
        <div className="oclBottom">
            <div className="oclBottomCompany">
                <div className="oclBottomTitle">
                {data.trust}
                </div>
                <div className="oclBottomLogos">
                    <img src={data.logo1} alt="logo1" />
                    <img src={data.logo2} alt="logo2"/>
                    <img src={data.logo3} alt="logo3"/>
                    <img src={data.logo4} alt="logo4"/>
                </div>
            </div>
            <div className="oclBottomButton">
                <Button onClick={onButtonClick} buttonText="Book a Demo" className="demoButton" arrowClassName="demoarrow" />
                <Link to={data.linkTo} className="knowButton" onClick={scrollToTop}>
                    <div className="knowMore">Know more</div><img src={images.knowArrow} alt="know-arrow" />
                </Link>
            </div>
        </div>
      </div>
      <div className="offeringCardRight">
            <img src={data.img}  alt="rightImg"/>
      </div>

      <div className="offeringCardMobile">
        <div className="oclTop">
          <div className="oclTopTitle">{data.name}</div>
          <div className="oclTopDetail">
            {data.detail}
          </div>
        </div>
        <div className="offeringCardRightMobile">
            <img src={data.img} alt="rightMobileImg" />
        </div>
        <div className="oclBottom">
            <div className="oclBottomCompany">
                <div className="oclBottomTitle">
                {data.trust}
                </div>
                <div className="oclBottomLogos">
                    <img src={data.logo1} alt="logo1" />
                    <img src={data.logo2} alt="logo2" />
                    <img src={data.logo3} alt="logo3" />
                    <img src={data.logo4} alt="logo4" />
                </div>
            </div>
            <div className="oclBottomButton">
                <Button onClick={onButtonClick} buttonText="Book a Demo" className="demoButton" arrowClassName="demoarrow" />
                <Link to={data.linkTo} className="knowButton" onClick={scrollToTop}>
                    <div className="knowMore">Know more</div><img src={images.knowArrow} alt="know-arrow" />
                </Link>
            </div>
        </div>
      </div>
    </div>
  );
}
